import { render, staticRenderFns } from "./backOrder.vue?vue&type=template&id=a167846e&scoped=true&"
import script from "./backOrder.vue?vue&type=script&lang=js&"
export * from "./backOrder.vue?vue&type=script&lang=js&"
import style0 from "./backOrder.vue?vue&type=style&index=0&id=a167846e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a167846e",
  null
  
)

export default component.exports